"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
var reducers_1 = require("../../login/reducers");
var reducers_2 = __importDefault(require("../../user/reducers"));
var reducers_3 = __importDefault(require("../components/pages/RootPage/reducers"));
var reducers_4 = __importDefault(require("../../home/reducers"));
var reducers_5 = __importDefault(require("../../directory/reducers"));
var reducers_6 = __importDefault(require("../../apiintegration/reducers"));
var rootReducer = redux_1.combineReducers({
    login: reducers_1.login,
    user: reducers_2.default,
    root: reducers_3.default,
    home: reducers_4.default,
    directory: reducers_5.default,
    api: reducers_6.default,
});
exports.default = rootReducer;
